import { render } from "./TPdefault.vue?vue&type=template&id=7fabaf5e"
import script from "./TPdefault.vue?vue&type=script&lang=js"
export * from "./TPdefault.vue?vue&type=script&lang=js"

import "./TPdefault.vue?vue&type=style&index=0&id=7fabaf5e&lang=css"

import exportComponent from "/root/workspace/A01_brandsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__